/**
 * See Array.isArray.
 */
export default function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
}
